import "./style.scss";
import { Table, Spin } from "antd";
import { useState } from "react";
import { TableTypes } from "./Table.model";
import { API_BASE_URL } from "../../../utilities/API_CONSTANT";
import { Http } from "../../../utilities/axios/http";
import { Assets } from "../../../assets";
// import { formatThousands } from "../../../utilities/formatNUmber";

type PropsType = {
  data: any;
  columns: TableTypes;
  size?: "small" | "middle" | "large";
  pagination?: false | any;
  rowHoverable?: boolean;
  linkToExtract?: string;
  borderedColumns?: boolean;
  timesheetSummary?: boolean;
  rowClassName?: (record: any) => string;
};

export const DisplayTable = ({
  columns,
  data,
  size = "small",
  pagination = false,
  rowHoverable = false,
  linkToExtract,
  borderedColumns = false,
  timesheetSummary = false,
  rowClassName,
}: PropsType) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleExtractClick = async () => {
    if (!linkToExtract) return;

    const url = `${API_BASE_URL}${linkToExtract}`;

    try {
      setIsDownloading(true);
      const res = await Http.getFile(url);

      const blob = new Blob([res.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "rapport.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div
      className={`dis_table ${
        borderedColumns ? "dis_table--bordered-columns" : ""
      }`}
    >
      {linkToExtract && (
        <div
          style={{
            marginBottom: "12px",
            textAlign: "right",
            marginRight: "24px",
            cursor: "pointer",
          }}
          className="extract-container"
        >
          {isDownloading ? (
            <Spin size="small" />
          ) : (
            <img
              src={Assets.icons.png.pdf}
              className="extract-icon"
              title="Télécharger PDF"
              width={"45px"}
              height={"50px"}
              onClick={handleExtractClick}
            />
          )}
        </div>
      )}
      <Table
        dataSource={data?.value}
        columns={columns}
        size={size}
        pagination={pagination}
        locale={{ emptyText: " Aucun résultat trouvé" }}
        rowHoverable={rowHoverable}
        rowClassName={(row) => {
          const classes = [];

          if (row?.isAuxiliary) {
            classes.push("ant-table-disable-row");
          }

          if (rowClassName) {
            classes.push(rowClassName(row));
          }

          return classes.filter(Boolean).join(" ");
        }}
        summary={
          timesheetSummary
            ? () => (
                <>
                  <Table.Summary.Row>
                    {/* DÉBARQUEMENT : Début + Fin */}
                    <Table.Summary.Cell
                      index={0}
                      colSpan={2}
                      className="timesheet-summary-label"
                    >
                      NOMBRE DE COLIS
                    </Table.Summary.Cell>

                    {/* DÉBARQUEMENT : Nature + T/M3 */}
                    <Table.Summary.Cell
                      index={2}
                      colSpan={2}
                      className="timesheet-summary-value"
                    >
                      {data?.totalLoad?.debarkationMovement ?? 0}
                    </Table.Summary.Cell>

                    {/* EMBARQUEMENT : Début + Fin */}
                    <Table.Summary.Cell
                      index={4}
                      colSpan={2}
                      className="timesheet-summary-label"
                    >
                      NOMBRE DE COLIS
                    </Table.Summary.Cell>

                    {/* EMBARQUEMENT : Nature + T/M3 */}
                    <Table.Summary.Cell
                      index={6}
                      colSpan={2}
                      className="timesheet-summary-value"
                    >
                      {data?.totalLoad?.embarkationMovement ?? 0}
                    </Table.Summary.Cell>

                    {/* Majoration */}
                    <Table.Summary.Cell index={8} />
                  </Table.Summary.Row>

                  <Table.Summary.Row>
                    {/* DÉBARQUEMENT : Début + Fin */}
                    <Table.Summary.Cell
                      index={0}
                      colSpan={2}
                      className="timesheet-summary-label"
                    >
                      POIDS TOTAL EN (T)
                    </Table.Summary.Cell>

                    {/* DÉBARQUEMENT : Nature + T/M3 */}
                    <Table.Summary.Cell
                      index={2}
                      colSpan={2}
                      className="timesheet-summary-value"
                    >
                      {data?.totalTonnage?.debarkationMovement ?? 0} T /{" "}
                      {data?.totalVolume?.debarkationMovement ?? 0} M3
                    </Table.Summary.Cell>

                    {/* EMBARQUEMENT : Début + Fin */}
                    <Table.Summary.Cell
                      index={4}
                      colSpan={2}
                      className="timesheet-summary-label"
                    >
                      POIDS TOTAL EN (T)
                    </Table.Summary.Cell>

                    {/* EMBARQUEMENT : Nature + T/M3 */}
                    <Table.Summary.Cell
                      index={6}
                      colSpan={2}
                      className="timesheet-summary-value"
                    >
                      {data?.totalTonnage?.embarkationMovement ?? 0} T /{" "}
                      {data?.totalVolume?.embarkationMovement ?? 0} M3
                    </Table.Summary.Cell>

                    {/* Majoration */}
                    <Table.Summary.Cell index={8} />
                  </Table.Summary.Row>
                </>
              )
            : undefined
        }
      />
    </div>
  );
};
